export default __webpack_public_path__ + "static/media/Nunito-ExtraLightItalic.061f1122.woff";